module.exports = __webpack_public_path__ + "static/media/transfer.fc2c33aa.svg";